import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CampaignObject } from "../types/APITypes";
import { assertNotNull } from "../util/helpers/assert";
import { useGetCampaigns } from "../hooks/useGetCampaigns";

export interface FiltersType {
    submitted : boolean;
    approved : boolean;
    launched : boolean;
    rejected : boolean;
    fiscal_year: number | null;
    fiscal_quarter: number | null;

}

const initialFilterState = {
    submitted : true,
    approved : false,
    launched : false,
    rejected : false,
    fiscal_year: null,
    fiscal_quarter: null
}

interface OverviewContextType {

    filters: FiltersType;
    setFilters: (f: FiltersType) => void;
}



const OverviewContext = createContext<OverviewContextType | null>(null);

export const useOverviewContext = () => assertNotNull(
    useContext(OverviewContext),
    "useOverviewContext must be called from a child of OverviewContext.Provider"
)

export const Provider = ({children} : React.PropsWithChildren) => {

    const [filters, setFilters] = useState<FiltersType>(initialFilterState);

    let campaignsResponse = useGetCampaigns();


    const providerValue = useMemo(() => ({
        filters, setFilters,
    }), [filters]);
    
    return (
        <OverviewContext.Provider value={providerValue}>
            {children}
        </OverviewContext.Provider>
    )
}